// ©2024 Austin App House. All rights reserved.
import React, { useMemo, useState } from 'react';
import { MDBRow } from 'mdbreact';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ExplanationInputModal from '../../modal/ExplenationInputModal';
import IconElement from './IconElement';
import prepareFilters from '../../../utils/prepareFilters';
import { getStatus } from '../../../utils/api/get/getWorkOrders';
import { toggleModal, toggleSecondModalClose } from '../../../storage/actions/modalsActions';
import {
  editOnHoldStatusWorkOrder,
  deleteWorkOrderDetails,
  cancelWorkOrder,
} from '../../../storage/actions/workOrdersActions';

const BulkElements = ({
  selectedWorkOrders,
  editOnHoldStatusWorkOrder,
  toggleModal,
  toggleSecondModalClose,
  activeTab,
  deleteWorkOrderDetails,
  history,
  cancelWorkOrder,
  search,
  filters,
  workOrders,
  profile
}) => {
  const [showModal, setShowModal] = useState(false);
  const mode = selectedWorkOrders?.length ? 'useIds' : 'useFilters';

  const requestData = useMemo(() => {
    const base = mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    return { ...base, ...getStatus(activeTab) };
  }, [mode, search, filters, activeTab, selectedWorkOrders]);

  const getReasonForCancelWorkOrder = async reason => {
    await cancelWorkOrder({ ...requestData, reason });
    toggleSecondModalClose('explanationInputModal', true);
    setShowModal(false);
  };

  const openModalToGetReason = () => {
    setShowModal(true);
    toggleModal(true, 'explanationInputModal', true, 'bulkCancel');
  };

  return (
    <>
      {
        activeTab === 'assigned'
          ? (
            <>
              <button
                aria-label="name"
                className="filter-icon-btn icon_fist"
                type="button"
                onClick={() => editOnHoldStatusWorkOrder({
                  ...requestData,
                  onHold: false,
                })}
                title={`Cancel Hold${mode === 'useFilters' ? ', All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
              <button
                aria-label="name1"
                className="filter-icon-btn icon_palm"
                type="button"
                onClick={() => editOnHoldStatusWorkOrder({
                  ...requestData,
                  onHold: true,
                })}
                title={`Hold${mode === 'useFilters' ? ' All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
              <button
                aria-label="name2"
                className="filter-icon-btn icon_messages"
                type="button"
                onClick={() => toggleModal(true, 'bulkMessageModal', false, { mode, workOrders })}
                title={`Send Message${mode === 'useFilters' ? ' to All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
              <button
                aria-label="name3"
                className="filter-icon-btn icon_quarters"
                type="button"
                onClick={openModalToGetReason}
                title={`Cancel WO${mode === 'useFilters' ? ', All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
              <button
                aria-label="name4"
                className="filter-icon-btn icon_add"
                type="button"
                onClick={() => toggleModal(true, 'unAssignModal', false, requestData)}
                title={`Un-assign WO${mode === 'useFilters' ? ', All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>



              {
                showModal
                  ? (
                    <ExplanationInputModal
                      returnExplanation={getReasonForCancelWorkOrder}
                      title={`Reason to cancel work order${mode === 'useFilters' ? ', All In Tab' : ''}`}
                      type="bulkCancel"
                      isCloseAvailable
                    />
                  )
                  : <></>
              }

            </>
          )
          : <></>
      }
      {
        activeTab === 'draft' || activeTab === 'available' || activeTab === 'routed'
          ? (
            <>
              <button
                aria-label="name"
                className="filter-icon-btn icon_delete"
                type="button"
                onClick={() => deleteWorkOrderDetails(requestData, history)}
                title={`Delete WO${mode === 'useFilters' ? ', All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>

              <button
                type="button"
                title={`Route WO${mode === 'useFilters' ? ', All In Tab' : ''}`}
                className="filter-icon-btn icon_telegram"
                onClick={() => toggleModal(
                  true,
                  'bulkWorkOrderRouteContractorModal',
                  false,
                  { mode },
                )}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
            </>
          )
          : <></>
      }
      {
        activeTab === 'draft' || activeTab === 'available' || activeTab === 'routed' || activeTab === 'assigned'
          ? (
            <>
              <button aria-label="name5" className="filter-icon-btn icon_pencil" type="button" onClick={() => toggleModal(true, 'bulkEditWorkOrders', false, { mode })} title={`Edit WO${mode === 'useFilters' ? ', All In Tab' : ''}`}>
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>

              {/* {mode !== 'useIds'
                  ? <label className="icon-label">ALL</label>
                  : <></>}
               */}


            </>
          )
          : <></>
      }
      {
        activeTab === 'completed' && profile?.clientUser?.accessctrl !== "Dispatcher"
          ? (
            <>
              <button
                className="filter-icon-btn icon_currency_dollar"
                type="button"
                title={`Approve${mode === 'useFilters' ? ' All In Tab' : ''}`}
                onClick={() => toggleModal(true, 'bulkWorkOrderApproveModal', false, { mode })}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
            </>
          )
          : <></>
      }
      {
        activeTab === 'available'
          ? (
            <>
              <button
                aria-label="name"
                className="filter-icon-btn icon_add"
                type="button"
                onClick={() => toggleModal(true, 'bulkWorkOrderAssignContractorModal', false, { mode })}
                title={`Assign WO${mode === 'useFilters' ? ', All In Tab' : ''}`}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>

            </>
          )
          : <></>
      }
      {
        activeTab === 'available' || activeTab === 'routed' || activeTab === 'completed'
          ? (
            <button
              aria-label="name"
              className="filter-icon-btn icon_messages"
              type="button"
              onClick={() => toggleModal(true, 'bulkMessageModal', false, { mode, workOrders })}
              title={`Send Message${mode === 'useFilters' ? ' to All In Tab' : ''}`}
            >
              {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
            </button>

          )
          : <></>
      }

      {
        activeTab === 'approved' && profile?.clientUser?.accessctrl !== "Dispatcher"
          ? (
            <>
              <button
                className="filter-icon-btn icon_arrow_dollar"
                type="button"
                title={`Mark selected wo's as Paid${mode === 'useFilters' ? ', All In Tab' : ''}`}
                onClick={() => toggleModal(true, 'bulkWorkOrderPay', false, { mode })}
              >
                {mode !== 'useIds' ? <label className="icon-label">ALL</label> : null}
              </button>
            </>
          )
          : <></>
      }
    </>
  );
};

const mapDispatchToProps = {
  toggleModal,
  toggleSecondModalClose,
  editOnHoldStatusWorkOrder,
  deleteWorkOrderDetails,
  cancelWorkOrder,
};

const mapStateToProps = state => ({
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  activeTab: state.applicationState.activeTab,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  profile: state.profile
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkElements));
